import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import * as _ from 'underscore';

import { Messages } from '../../../codegen/Localize';
import { IServerUserInfo } from '../../../ts/models/IServerUserInfo';
import { Set } from '../../../ts/models/Set';
import { EditSiteMembershipAction } from '../../../userManagement/services/EditSiteMembershipAction';
import { AddActiveDirectoryUsersAction } from '../../../userManagement/services/AddActiveDirectoryUsersAction';
import { RemoveUsersAction } from '../../../userManagement/services/RemoveUsersAction';
import { ServerUserDelete, ServerUserEditSiteMembership, ServerUserForcePasswordUpdate, ServerUserResetLoginRateLimiting
} from '../../actions/AppActionTypes';
import { requestFailed } from '../../actions/RequestFailedAction';
import { ServerUserMenuAction } from '../../actions/spaces/ServerUserMenuActions';
import { ServiceLocator } from '../../ServiceLocator';
import { reloadSpace } from './content/RefreshContentSagas';
import { forcePasswordUpdateOnServerUsers } from '../../../authentication/actions/ForcePasswordUpdateAction';
import { resetLoginRateLimitingOnServerUsers } from '../../../authentication/actions/ResetLoginRateLimitingAction';

export function deleteUsers(users: IServerUserInfo[]) {
  return RemoveUsersAction.showDeleteUsersFromServerDialog(Set.fromIdItemArray(users));
}

export function* handleDeleteUsers(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(deleteUsers, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    // This is to prevent error notifcation from showing up when the dialog is dismissed
    // To be fixed after TFSID 1121927
    return;
  }
}

export function editSiteMembership(users: IServerUserInfo[]) {
  return EditSiteMembershipAction.showEditSiteMembershipDialog(Set.fromIdItemArray(users));
}

export function* handleEditSiteMembership(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(editSiteMembership, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function forcePasswordUpdate(users: IServerUserInfo[]) {
  return forcePasswordUpdateOnServerUsers(Set.fromIdItemArray(users));
}

export function* handleForcePasswordUpdate(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(forcePasswordUpdate, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function resetLoginRateLimiting(users: IServerUserInfo[]) {
  return resetLoginRateLimitingOnServerUsers(Set.fromIdItemArray(users));
}

export function* handleResetLoginRateLimiting(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(resetLoginRateLimiting, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function* rootServerUserMenuActionSaga(): SagaIterator {
  yield takeEvery(ServerUserEditSiteMembership, handleEditSiteMembership);
  yield takeEvery(ServerUserDelete, handleDeleteUsers);
  yield takeEvery(ServerUserForcePasswordUpdate, handleForcePasswordUpdate);
  yield takeEvery(ServerUserResetLoginRateLimiting, handleResetLoginRateLimiting);
}
